import styled from 'styled-components'

import COLORS from 'constants/colors'

export const Wrapper = styled.div`
  padding-top: 40px;
  position: relative;
  padding-bottom: 40px;
  margin-top: 20px;

  .rc-slider {
    margin: 20px 0;
    position: relative;
    touch-action: none;
    display: block;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.4);
    height: 12px;
    border-radius: 10px;
  }
  .rc-slider-rail {
    background-color: transparent;
  }
  .rc-slider-track {
    height: 100%;
    border-radius: 10px;
    top: 0;
    background-color: #f3dd93;
  }

  .rc-slider-dot {
    background: #fff;
    border: 1px solid #ccc;
    cursor: pointer;
    display: inline-block;
    position: absolute;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 -1px 3px rgba(0, 0, 0, 0.4);
    width: 30px;
    height: 30px;
    border-radius: 30px;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
  .rc-slider-dot:after {
    content: ' ';
    position: absolute;
    width: 16px;
    height: 16px;
    top: 6px;
    left: 6px;
    border-radius: 50%;
    background-color: #dadada;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4) inset,
      0 -1px 3px rgba(0, 0, 0, 0.4) inset;
  }

  .rc-slider-dot .rc-slider-dot-active {
    opacity: 1;
  }

  .rc-slider-mark {
    position: relative;
    list-style-type: none;
    padding: 0;
    text-align: left;
    height: 100%;
  }

  .rc-slider-mark-text {
    position: absolute;
    font-size: 18px;
    cursor: pointer;
    display: inline-block;
    top: 10px;
    transform: translate3d(-50%, 0, 0);
    margin-left: -3px;
  }
  .rc-slider-handle {
    border: none;
    background: #f3dd93;
    margin-left: -4px;
  }

`

export const Output = styled.div`
  background: ${COLORS.GREYMEDIUM};
  border-radius: 2px;
  box-shadow: inset 0px 1px 4px rgba(0, 0, 0, 0.2);
  font-size: 22px;
  padding: 5px 15px;
  border: 1px solid #999999;
  position: absolute;
  top: 0;
  right: 0;
`
